import { ROUTE_DASHBOARD, ROUTE_HOME } from '@/constants/routes';
import useUser from '@/hooks/useUser';

export function useHomeRoute() {
  const { data } = useUser();
  return data.loggedIn ? ROUTE_DASHBOARD : ROUTE_HOME;
}
